var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "tippy",
          rawName: "v-tippy",
          value: {
            theme: "assigned-select",
            interactive: _vm.tippyInteractive,
            interactiveBorder: 10,
            content: _vm.tippyContent,
            boundary: _vm.tippyBoundary,
            placement: "bottom",
            popperOptions: {
              modifiers: {
                flip: {
                  boundariesElement: _vm.tippyBoundary,
                  flipVariationsByContent: true,
                },
              },
            },
          },
          expression:
            "{\n    theme: 'assigned-select',\n    interactive: tippyInteractive,\n    interactiveBorder: 10,\n    content: tippyContent,\n    boundary: tippyBoundary,\n    placement: 'bottom',\n    popperOptions: {\n      modifiers: {\n        flip: {\n          boundariesElement: tippyBoundary,\n          flipVariationsByContent: true\n        },\n      },\n    }\n  }",
        },
      ],
      class: [_vm.$.resources_wrap, _vm.isActive ? _vm.$.active : ""],
      on: {
        click: function (e) {
          return _vm.$emit("onClick", e)
        },
      },
    },
    [
      _vm._l(_vm.visibleResources, function (item) {
        return _c("div", [
          item.isRest
            ? _c("div", { class: _vm.$.rest }, [
                _vm._v("\n      " + _vm._s(item.name) + "\n    "),
              ])
            : _c("div", {
                class: _vm.$.avatar,
                style: {
                  backgroundImage: "url('" + item.avatar + "')",
                },
              }),
        ])
      }),
      _vm._v(" "),
      !_vm.resources.length
        ? _c(
            "div",
            { class: _vm.$.avatar },
            [
              _c("svg-sprite", {
                style: { color: "#999" },
                attrs: { name: "assigned", size: 24 },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }